var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9239 2.21811C18.1428 1.43706 16.8765 1.43706 16.0954 2.21811L14.873 3.44052L19.7556 8.32309L20.978 7.10067C21.759 6.31962 21.759 5.05329 20.978 4.27224L18.9239 2.21811ZM18.3543 9.72434L13.4718 4.84178L3.67861 14.6349C3.47711 14.8364 3.321 15.0787 3.22073 15.3454L1.9834 18.6369C1.37865 20.2456 2.95054 21.8175 4.55925 21.2127L7.85071 19.9754C8.11745 19.8751 8.35967 19.719 8.56117 19.5175L18.3543 9.72434Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.8502H20.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencil_white.6c9d634d898cf39a971c5a1cfc1acff5.svg";
export { ForwardRef as ReactComponent };